module.exports = __webpack_public_path__ + "img/other_samsung2.84ced830.jpg";